"use client";

import { useRef, useState, useLayoutEffect } from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import styles from "./style.module.scss";
import TransitionLink from "@/components/common/TransitionLink";
import Link from "next/link";
import MobileMenu from "./MobileMenu";

gsap.registerPlugin(ScrollTrigger, Flip);

const navList = [
	{
		id: "1.1",
		label: (
			<>
				Work ▸ <span>12</span>
			</>
		),
		link: "/projects",
	},
	{
		id: "1.2",
		label: "The studio",
		link: "/the-studio",
	},
	// {
	// 	id: "1.3",
	// 	label: "Playground",
	// 	link: "/playground",
	// },
	{
		id: "1.3",
		label: "Contact",
		link: "/contact",
	},
];

const Nav = () => {
	const navRef = useRef<HTMLElement>(null);
	const navListRef = useRef<HTMLUListElement>(null);
	const [isScrolled, setIsScrolled] = useState(false);
	const [isCollapsed, setIsCollapsed] = useState(false);
	const [isHovering, setIsHovering] = useState(false);
	const [isHidden, setIsHidden] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const flipStateRef = useRef<any>(null);
	const pathname = usePathname();

	// Animate after collapse or hover state changes
	// useLayoutEffect(() => {
	// 	if (!navListRef.current || !flipStateRef.current) return;

	// 	// Animate from the previous state to the new state
	// 	Flip.from(flipStateRef.current, {
	// 		targets: navListRef.current.querySelectorAll("li"),
	// 		duration: 0.5,
	// 		ease: "power2.inOut",
	// 		absolute: true,
	// 		onEnter: (elements) => {
	// 			return gsap.fromTo(
	// 				elements,
	// 				{
	// 					opacity: 0,
	// 					y: -15,
	// 				},
	// 				{
	// 					opacity: 1,
	// 					y: 0,
	// 					duration: 0.4,
	// 					ease: "power2.out",
	// 				}
	// 			);
	// 		},
	// 		onLeave: (elements) => {
	// 			return gsap.to(elements, {
	// 				opacity: 0,
	// 				y: -15,
	// 				duration: 0.3,
	// 				ease: "power2.in",
	// 			});
	// 		},
	// 	});
	// }, [isCollapsed, isHovering]);

	// Determine if we should show "Say Hello" link
	// Show it if: (1) not on home page, OR (2) on home page and scrolled

	// Filter nav items based on collapsed state and hover
	// Show all items if: not collapsed OR (collapsed but hovering)
	const visibleNavItems = navList;

	// Determine nav theme classes
	const navClasses = [styles.nav, styles.otherNav, isScrolled && styles["nav--scrolled"]].join(" ");

	return (
		<>
			<nav ref={navRef} className={navClasses} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
				<div className={styles["nav__right-section"]}>
					<Link href="/">
						<Image src="/images/logo.svg" alt="parallel lab" width={44.03} height={40} />
					</Link>
					<ul ref={navListRef} className={styles["nav__list"]}>
						{visibleNavItems.map((navItem) => (
							<li key={navItem.id}>
								<Link href={navItem.link} prefetch>
									<span>{navItem.id}</span>
									{navItem.label}
								</Link>
							</li>
						))}
					</ul>
				</div>
				<div className={styles["nav__left-section"]}>
					<Link href="/contact" className={styles["nav__say-hello"]} prefetch>
						Say Hello
					</Link>
					<button className={styles["nav__hamburger"]} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}>
						MENU
					</button>
				</div>
			</nav>
			<MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
		</>
	);
};

export default Nav;
